import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useRouter } from '@loyalup/core';

import WithTitle from '../WithTitle';
import Button from '../Button';

import { ReactComponent as LogoRed } from 'icons/logo-red.svg';
import { ReactComponent as ErrorFace } from 'icons/error-face.svg';

import s from './GlobalError.module.css';

//TODO: remove this styles after refactoring buttons (shapes/colors)
const buttonStyles = {
  background: '#ed5f4c',
  borderColor: '#ed5f4c',
};

const TITLES = {
  'not-found': 'Страница не найдена',
  connection: 'Ошибка соединения',
};

const MESSAGES = {
  'not-found': 'Неверная ссылка, либо страница была перемещена',
  connection: 'Потеряна связь с сервером',
};

const GlobalError = ({ type }) => {
  const [t] = useTranslation();
  const { Link } = useRouter();

  return (
    <WithTitle title={t(TITLES[type])}>
      <div className={s.root}>
        <main className={s.main}>
          <LogoRed width="62px" height="62px" />
          <b className={s.companyName}>Loyal Up</b>
          <Button style={buttonStyles} className={s.button} theme="square">
            <ErrorFace className={s.icon} />
            {t(TITLES[type])}
          </Button>
          <h1 className={s.title}>{t(MESSAGES[type])}</h1>
          {type === 'not-found' && (
            <p className={s.actions}>
              {t('Перейдите на')}
              <a href="/" className={s.link}>
                {t('домашнюю страницу')}
              </a>
              {t('или')}
              <a href="mailto:support@loyal-up.com" className={s.link}>
                {t('сообщите нам')}
              </a>
              {t('о проблеме')}
            </p>
          )}
          {type === 'connection' && (
            <p className={s.actions}>
              <Link to="/" component="a" className={s.link} onClick={() => window.location.reload()}>
                {t('Перезагрузите страницу')}
              </Link>
              {t('или')}
              <a href="mailto:support@loyal-up.com" className={s.link}>
                {t('сообщите нам')}
              </a>
              {t('о проблеме')}
            </p>
          )}
        </main>
      </div>
    </WithTitle>
  );
};

GlobalError.propTypes = {
  type: PropTypes.oneOf(['not-found', 'connection']),
};

export default GlobalError;
